export { useUpdateTermsOfUseQuery } from './useUpdateTermsOfUseQuery';
